<script setup lang="ts">
import {ChevronDown} from 'lucide-vue-next';
import SectionHeading from '../components/SectionHeading.vue';
import {useLanguage} from '../composables/useLanguage';

const {isArabic} = useLanguage();

const faqs = [
  {
    qAr: 'ما نوع المشاريع التي تنفذونها؟',
    qEn: 'What kinds of projects do you deliver?',
    aAr: 'ننفذ مشاريع المقاولات العامة، والبنية التحتية، والاستثمار العقاري، وإدارة المشاريع من البداية حتى التسليم.',
    aEn: 'We deliver general contracting, infrastructure, real estate investment, and project management from concept to handover.',
  },
  {
    qAr: 'هل تعملون خارج طرابلس؟',
    qEn: 'Do you work outside Tripoli?',
    aAr: 'نعم، نغطي عدة مدن ومناطق داخل ليبيا حسب نطاق المشروع ومتطلباته.',
    aEn: 'Yes. We operate across multiple cities and regions in Libya depending on the project scope and requirements.',
  },
  {
    qAr: 'كيف أبدأ مشروعًا معكم؟',
    qEn: 'How do I start a project with you?',
    aAr: 'يمكنك التواصل معنا مباشرة عبر صفحة الاتصال، وسنراجع نطاق المشروع ونقترح الخطوة التالية المناسبة.',
    aEn: 'You can contact us directly through the Contact page and we’ll review the scope and recommend the next step.',
  },
  {
    qAr: 'هل تقدمون إدارة كاملة للمشروع؟',
    qEn: 'Do you provide full project management?',
    aAr: 'نعم، لدينا إدارة متكاملة تشمل التخطيط، والميزانية، والتنفيذ، والتنسيق، والتسليم.',
    aEn: 'Yes. We provide end-to-end management including planning, budgeting, execution, coordination, and handover.',
  },
];
</script>

<template>
  <section class="page-shell">
    <div class="container page-hero">
      <SectionHeading
        align="start"
        :eyebrow="isArabic ? 'الأسئلة الشائعة' : 'Frequently asked questions'"
        :title="isArabic ? 'إجابات واضحة قبل أن نبدأ العمل' : 'Clear answers before we get started'"
        :description="isArabic
          ? 'جمعنا هنا أهم الأسئلة التي تساعدك على فهم طريقة عملنا وخدماتنا.'
          : 'We’ve gathered the most common questions to help you understand how we work and what we offer.'"
      />
    </div>
    <div class="container page-grid page-grid--faq">
      <details v-for="faq in faqs" :key="faq.qEn" class="faq-item reveal">
        <summary>
          <span>{{ isArabic ? faq.qAr : faq.qEn }}</span>
          <ChevronDown :size="18" />
        </summary>
        <p>{{ isArabic ? faq.aAr : faq.aEn }}</p>
      </details>
    </div>
  </section>
</template>
